var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard"},[_c('h1',[_vm._v("Not Found"),_c('Br'),_vm._v("(In Development?)")],1)])}
var staticRenderFns = []

export { render, staticRenderFns }